import * as React from 'react';
import { useSelector } from 'react-redux';
import { ReferralsListLayout } from '../../../components/ReferralsList';
import { ReferralsListItemContainer } from './ReferralsListItemContainer';
import { selectReferralsList } from '../../../selectors';

export const ReferralsListContainer: React.FC = () => {
  const referrals = useSelector(selectReferralsList);
  const hasReferral = !!referrals.length;

  if (!hasReferral) {
    return null;
  }

  return (
    <ReferralsListLayout>
      {referrals.map(referral => (
        <ReferralsListItemContainer key={referral.phone} {...referral} />
      ))}
    </ReferralsListLayout>
  );
};
